<script>
    import { projectState } from "@app/store/projectStore.svelte.js";
    import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
    import { modalState, hideModal } from "@app/store/modalStore.svelte.js";
    import { fade } from "svelte/transition";
    import { toast } from "@zerodevx/svelte-toast";
    import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
    import _FrameRates from "@cclib/dict/frameRates.js";
    import tcLib from '@cclib/lib/timecode.js'
    import incodeTime from '@cclib/lib/incodeTime.js'
    import tcRound from "@cclib/functions/eventGroups/tcRound.js";
    import * as m from '@app/paraglide/messages.js';
    let frameRate = $state(projectState.frameRate);
    let dropFrame = $state(projectState.dropFrame);
    let incode = $state(incodeTime.mediaSecondsToIncodeLabel(projectState.incode, projectState.frameRate, projectState.dropFrame));
    
    function validateTc(e) {
        incode = tcLib.tcValidate(e.target.value, frameRate, dropFrame);
    }

    function handleSubmit(e) {
        e.preventDefault();
        updateProjectTimingSettings();
    }

    function updateProjectTimingSettings(){
        projectState.frameRate = frameRate;
        if (_FrameRates.dropFrameMap[frameRate]) {
            projectState.dropFrame = dropFrame;
        } else {
            projectState.dropFrame = false;
        }

        
        incode = tcLib.tcValidate(incode, projectState.frameRate, projectState.dropFrame);
        projectState.incode = incodeTime.incodeLabelToMediaSeconds(incode, projectState.frameRate, projectState.dropFrame);
    
        eventGroupState.forEach(evg => {
            evg = tcRound(evg, projectState.frameRate, projectState.dropFrame);
        });

        insertHistoryAction({
            name: "update project timing settings", //action name
            eventGroup: projectState.selected,
            snapshots: [
                {
                    store: "projectState",
                    value: JSON.stringify(projectState),
                },
                {
                    store: "eventGroupState",
                    value: JSON.stringify(eventGroupState),
                }
            ],
        });


        toast.push(m.project_timing_settings_updated(), {
            classes: ["toast-info"],
        });

        hideModal();      
    }
</script>

<div
    transition:fade={{ duration: 100 }}
    class="modal {modalState.selected === 'projectTimingSettings'
        ? 'show d-block'
        : ''}"
    role="dialog"
    aria-labelledby="timingSettingsTitle"
    tabindex="-1"
    id="ProjectTimingSettingsModal"
>
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="timingSettingsTitle">{m.timing_settings()}</h4>
                <button
                    type="button"
                    class="btn-close"
                    id="closeTimingSettings"
                    aria-label={m.close()}
                    onclick={() => hideModal()}
                ></button>
            </div>
            <div class="modal-body">
                <form onsubmit={handleSubmit} id="ProjectTimingSettingsForm" aria-label={m.project_timing_settings_form()}>
                    <p class="lead text-warning" id="frameRateLabel">{m.project_frame_rate()}</p>
                    <div class="row" role="radiogroup" aria-labelledby="frameRateLabel">
                        <div class="mb-3 col-3">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="frOption1"
                                    bind:group={frameRate}
                                    name="frameRate"
                                    value={23.976}
                                />
                                <label class="form-check-label" for="frOption1"
                                    >23.976</label
                                >
                            </div>
                        </div>
                        <div class="mb-3 col-3">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="frOption2"
                                    bind:group={frameRate}
                                    name="frameRate"
                                    value={24}
                                />
                                <label class="form-check-label" for="frOption2"
                                    >24</label
                                >
                            </div>
                        </div>
                        <div class="mb-3 col-3">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="frOption3"
                                    bind:group={frameRate}
                                    name="frameRate"
                                    value={25}
                                />
                                <label class="form-check-label" for="frOption3"
                                    >25</label
                                >
                            </div>
                        </div>
                        <div class="mb-3 col-3">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="frOption4"
                                    bind:group={frameRate}
                                    name="frameRate"
                                    value={29.97}
                                />
                                <label class="form-check-label" for="frOption4"
                                    >29.97</label
                                >
                            </div>
                        </div>

                        <div class="mb-3 col-3">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="frOption5"
                                    bind:group={frameRate}
                                    name="frameRate"
                                    value={30}
                                />
                                <label class="form-check-label" for="frOption5"
                                    >30</label
                                >
                            </div>
                        </div>
                        <div class="mb-3 col-3">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="frOption6"
                                    bind:group={frameRate}
                                    name="frameRate"
                                    value={59.94}
                                />
                                <label class="form-check-label" for="frOption6"
                                    >59.94</label
                                >
                            </div>
                        </div>
                        <div class="mb-3 col-3">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    id="frOption7"
                                    bind:group={frameRate}
                                    name="frameRate"
                                    value={60}
                                />
                                <label class="form-check-label" for="frOption7"
                                    >60</label
                                >
                            </div>
                        </div>
                    </div>
                    {#if [29.97, 59.94].indexOf(frameRate) > -1}
                        <div class="mb-3">
                            <p class="lead text-warning" id="dropFrameLabel">{m.project_drop_frame()}</p>
                            <div class="form-check">
                                <input
                                    id="dropFrameCheckbox"
                                    class="form-check-input"
                                    type="checkbox"
                                    bind:checked={dropFrame}
                                    aria-label={m.enable_drop_frame_timecode()}
                                />
                                <label
                                    class="form-check-label"
                                    for="dropFrameCheckbox"
                                >
                                    {m.drop_frame()}
                                </label>
                            </div>
                        </div>
                    {/if}
                    <p class="lead text-warning" id="incodeLabel">{m.project_incode()}</p>
                    <div class="mb-3">
                        <input
                            placeholder={m.timecode_placeholder()}
                            type="text"
                            class="form-control"
                            id="incodeInput"
                            bind:value={incode}
                            onblur={validateTc}
                            onkeyup={(e) => e.key === "Enter" && validateTc(e)}
                            onfocus={(e) => {
                                e.target.select();
                            }}
                            aria-labelledby="incodeLabel"
                        />
                    </div>
                    <button
                        class="btn btn-primary float-end"
                        type="submit"
                        id="updateTimingBtn"
                        aria-label={m.update_timing_settings()}
                    >{m.update_settings()}</button>
                </form>
            </div>
        </div>
    </div>
</div>
